import lazyComponent from './main.vue';
export default lazyComponent;
